module.exports = __webpack_public_path__ + "img/compromissoFael.4e82fa07.png";